import { openExternalUrl } from '../openExternalUrl'
import type { IPlatformAdapter } from '../ports/IPlatformAdapter'
import type {
  BackButtonOptions,
  HapticStyle,
  MainButtonOptions,
  PlatformLaunchPayload,
  PlatformTheme,
} from '../ports/types'
import {
  readStartParamFromLocation,
  resolveDevPayload,
} from '../resolveDevLaunchPayload'

export interface DevPlatformAdapterOptions {
  /** Optional startParam override (runtimeConfig or query). */
  startParam?: string | null
  /**
   * Real Telegram initData or VK launch query for `POST auth/mini-app`.
   * There is no server `provider=dev` — this must verify against a Mini App channel.
   */
  payload?: string | null
}

/**
 * Local / e2e adapter. Supplies a frontend fake/test payload for a real Mini App
 * channel. Activated only when `import.meta.dev` and `NUXT_PUBLIC_MINIAPP_DEV`.
 */
export class DevPlatformAdapter implements IPlatformAdapter {
  readonly kind = 'dev' as const

  private startParam: string | null
  private configuredPayload: string | null

  constructor(options: DevPlatformAdapterOptions = {}) {
    this.startParam = options.startParam ?? readStartParamFromLocation()
    this.configuredPayload = options.payload ?? null
  }

  async init(): Promise<PlatformLaunchPayload> {
    const raw = resolveDevPayload(this.configuredPayload)
    return {
      kind: this.kind,
      raw,
      startParam: this.startParam,
    }
  }

  getTheme(): PlatformTheme {
    return {
      colorScheme: 'light',
      bgColor: '#ffffff',
      textColor: '#111111',
      buttonColor: '#2481cc',
      buttonTextColor: '#ffffff',
    }
  }

  setMainButton(_options: MainButtonOptions | null): void {
    // Chrome (task 04) will render an in-app primary; no native host in dev.
  }

  setBackButton(_options: BackButtonOptions | null): void {}

  haptic(_style?: HapticStyle): void {}

  close(): void {
    // no-op in browser
  }

  openLink(url: string): void {
    openExternalUrl(url)
  }

  async requestContact(): Promise<string | null> {
    return null
  }

  getStartParam(): string | null {
    return this.startParam
  }
}
